import React from "react";
import { ShimmerTable, ShimmerThumbnail } from "react-shimmer-effects";
import { API_ENDPOINTS } from "../constants/endPoints";


export const TableShimmer = ({ rows = API_ENDPOINTS?.shimmer_row_limit || 10,cols = API_ENDPOINTS?.shimmer_col_limit || 5, }) => {
  return (
    <div style={{ padding: "16px" }}>
      <ShimmerTable row={rows} col={cols} />
    </div>
  );
};


export const renderShimmerCard = (count = 5, width = 200, height = 180) => {
  const thumbnails = [];
  for (let i = 0; i < count; i++) {
    thumbnails.push(
      <ShimmerThumbnail key={i} width={width} height={height} />
    );
  }
  return thumbnails;
};
